const ENTITY_PATH: Record<string, string> = {
  Purchase: 'expense',
  Bill: 'bill',
  VendorCredit: 'vendorcredit',
  JournalEntry: 'journal',
}

/** Build a QuickBooks Online deep link for a transaction. */
export function qboTxnUrl(entityType: string | null | undefined, id: string): string {
  const key = entityType?.trim() || ''
  const path = ENTITY_PATH[key] ?? 'bill'
  return `https://app.qbo.intuit.com/app/${path}?txnId=${id}`
}
